import { Routes, Route, Link, Navigate } from "react-router-dom";
import { Authenticator, Flex, Heading, Button } from "@aws-amplify/ui-react";
import DevicesPage from "./pages/DevicesPage";
import DeviceDetail from "./pages/DeviceDetail";
import AddDevice from "./pages/AddDevice";
import EventsPage from "./pages/EventsPage";
import SettingsPage from "./pages/SettingsPage";
import EditDevice from "./pages/EditDevice";
import TestPage from "./pages/TestPage";
import TestPage2 from "./pages/TestPage2";
import TopNav from "./layout/TopNav";
import ProtectedRoute from "./routes/ProtectedRoute";
import LoginPage from "./routes/LoginPage";
import AuthGate from "./routes/AuthGate";
import { AdminTenantProvider } from "./admin/AdminTenantContext";

export default function App() {
  return (
    <Authenticator.Provider>
      <AuthGate>
        <AdminTenantProvider>
          <Flex direction="column" minHeight="100vh">
            <TopNav />
            <Flex as="main" direction="column" padding="1rem" flex="1">
              <Routes>
                <Route path="/" element={<Navigate to="/devices" replace />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/devices" element={<ProtectedRoute><DevicesPage /></ProtectedRoute>} />
                <Route path="/devices/:deviceId" element={<ProtectedRoute><DeviceDetail /></ProtectedRoute>} />
                <Route path="/devices/:deviceId/edit" element={<ProtectedRoute><EditDevice /></ProtectedRoute>} />
                <Route path="*" element={<Heading level={5}>Not found</Heading>} />
                <Route path="/devices/add" element={<ProtectedRoute><AddDevice /></ProtectedRoute>} />
                <Route path="/events" element={<ProtectedRoute><EventsPage /></ProtectedRoute>} />
                <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
                <Route path="/test" element={<TestPage />} />
                <Route path="/test2" element={<TestPage2 />} />
              </Routes>
            </Flex>
          </Flex>
        </AdminTenantProvider>
      </AuthGate>
    </Authenticator.Provider>
  );
}
